module.exports = __webpack_public_path__ + "static/img/cjx12.2a2b937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx12.png
// module id = 169
// module chunks = 0